module.exports = __webpack_public_path__ + "static/media/st.ff38ed21.svg";